module.exports = __webpack_public_path__ + "img/grey_027.e9737ccd.png";